/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SessionDataLogService } from '../services/session-data-log/session-data-log.service';

@Injectable()
export class SessionDataInterceptor implements HttpInterceptor {
  constructor(private sessionDataLog: SessionDataLogService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.sessionDataLog.getEncryptedSessionMetadata(req.url, req.method)).pipe(
      switchMap((encryptedMetadata) => {
        let modifiedReq: HttpRequest<any>;

        if (req.method === 'GET') {
          const params = req.params.set('sessionMetadata', encryptedMetadata);
          modifiedReq = req.clone({ params });
        } else {
          const body = {
            ...req.body,
            sessionMetadata: encryptedMetadata,
          };
          modifiedReq = req.clone({ body });
        }
        return next.handle(modifiedReq);
      }),
    );
  }
}
